import React from 'react';

export function PageHeader({ title, subtitle, actions, meta, children }) {
  return (
    <div className="tk-page-header">
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <h2>{title}</h2>
          {meta || null}
        </div>
        {subtitle ? <p>{subtitle}</p> : null}
        {children}
      </div>
      {actions ? <div className="tk-page-header-actions">{actions}</div> : null}
    </div>
  );
}

export function Surface({ children, className = '', padded = true, interactive = false, as: Tag = 'div', ...rest }) {
  return (
    <Tag
      className={`tk-surface ${padded ? 'tk-surface-pad' : ''} ${interactive ? 'tk-surface-interactive' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function SectionTitle({ children }) {
  return <h3 className="tk-section-title">{children}</h3>;
}

export function Toolbar({ children, className = '' }) {
  return <div className={`tk-toolbar ${className}`.trim()}>{children}</div>;
}

export function TicketTable({ children, className = '' }) {
  return (
    <div className={`tk-table-wrap ${className}`.trim()}>
      <table className="tk-table">{children}</table>
    </div>
  );
}

export function SkeletonBlock({ rows = 6 }) {
  return (
    <div className="tk-surface tk-surface-pad" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="tk-skeleton tk-skeleton-row" style={{ opacity: 1 - i * 0.07 }} />
      ))}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="tk-empty">
      {Icon ? (
        <div className="tk-empty-icon">
          <Icon size={28} weight="duotone" />
        </div>
      ) : null}
      <p className="tk-empty-title">{title}</p>
      {description ? <p className="tk-empty-desc">{description}</p> : null}
      {action || null}
    </div>
  );
}

export function Alert({ variant = 'info', children }) {
  return <div className={`tk-alert tk-alert-${variant}`}>{children}</div>;
}

export function CountChip({ children }) {
  return <span className="tk-count-chip">{children}</span>;
}
